import { MESSENGERS } from '@mssgme/shared';

import FACEBOOK_MESSENGER_LOGO from '@mssgme/ui/img/brands/facebook-messenger.svg';
import SKYPE_LOGO from '@mssgme/ui/img/brands/skype.svg';
import TELEGRAM_LOGO from '@mssgme/ui/img/brands/telegram.svg';
import VIBER_LOGO from '@mssgme/ui/img/brands/viber.svg';
import VKONTAKTE_LOGO from '@mssgme/ui/img/brands/vkontakte.svg';
import WHATSAPP_LOGO from '@mssgme/ui/img/brands/whatsapp.svg';

const NO_DESKTOP_APP = ['vk', 'messenger'];

const MESSENGER_BRANDS = {
    whatsapp: {
        label: 'WhatsApp',
        color: '#24d366',
        downloadUrl: 'https://www.whatsapp.com/download/',
        logo: WHATSAPP_LOGO,
    },
    telegram: {
        label: 'Telegram',
        color: '#1f98d4',
        downloadUrl: 'https://telegram.org/',
        logo: TELEGRAM_LOGO,
    },
    viber: {
        label: 'Viber',
        color: '#665cac',
        downloadUrl: 'https://www.viber.com/download/',
        logo: VIBER_LOGO,
    },
    messenger: {
        label: 'Facebook Messenger',
        color: '#0284ff',
        logo: FACEBOOK_MESSENGER_LOGO,
    },
    vk: {
        label: 'Vkontakte',
        color: '#5b88bd',
        logo: VKONTAKTE_LOGO,
    },
    skype: {
        label: 'Skype',
        color: '#00aff0',
        downloadUrl: 'https://www.skype.com/get-skype/',
        logo: SKYPE_LOGO,
    },
};

export { MESSENGERS as AVAILABLE_MESSENGERS, NO_DESKTOP_APP, MESSENGER_BRANDS };
